import script from "./config-product.vue?vue&type=script&lang=tsx&setup=true"
export * from "./config-product.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__